function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * This file contains an runtime version of `styled` component. Responsibilities of the component are:
 * - returns ReactElement based on HTML tag used with `styled` or custom React Component
 * - injects classNames for the returned component
 * - injects CSS variables used to define dynamic styles based on props
 */
import * as React from 'react'; // eslint-disable-line import/no-extraneous-dependencies

import validAttr from '@emotion/is-prop-valid';
import { cx } from '../index'; // Workaround for rest operator

var restOp = function restOp(obj, keysToExclude) {
  return Object.keys(obj).filter(function (prop) {
    return !keysToExclude.includes(prop);
  }).reduce(function (acc, curr) {
    return Object.assign(acc, _defineProperty({}, curr, obj[curr]));
  }, {});
}; // rest operator workaround


var warnIfInvalid = function warnIfInvalid(value, componentName) {
  if (process.env.NODE_ENV !== 'production') {
    if (typeof value === 'string' || // eslint-disable-next-line no-self-compare
    typeof value === 'number' && isFinite(value)) {
      return;
    }

    var stringified = _typeof(value) === 'object' ? JSON.stringify(value) : String(value); // eslint-disable-next-line no-console

    console.warn("An interpolation evaluated to '".concat(stringified, "' in the component '").concat(componentName, "', which is probably a mistake. You should explicitly cast or transform the value to a string."));
  }
}; // If styled wraps custom component, that component should have className property


function styled(tag) {
  return function (options) {
    if (process.env.NODE_ENV !== 'production') {
      if (Array.isArray(options)) {
        // We received a strings array since it's used as a tag
        throw new Error('Using the "styled" tag in runtime is not supported. Make sure you have set up the Babel plugin correctly. See https://github.com/callstack/linaria#setup');
      }
    }

    var render = function render(props, ref) {
      var _props$as = props.as,
          component = _props$as === void 0 ? tag : _props$as,
          className = props.class;
      var rest = restOp(props, ['as', 'class']);
      var filteredProps; // Check if it's an HTML tag and not a custom element

      if (typeof component === 'string' && component.indexOf('-') === -1) {
        filteredProps = {}; // eslint-disable-next-line guard-for-in

        for (var key in rest) {
          if (key === 'as' || validAttr(key)) {
            // Don't pass through invalid attributes to HTML elements
            filteredProps[key] = rest[key];
          }
        }
      } else {
        filteredProps = rest;
      }

      filteredProps.ref = ref;
      filteredProps.className = cx(filteredProps.className || className, options.class);
      var vars = options.vars;

      if (vars) {
        var style = {}; // eslint-disable-next-line guard-for-in

        for (var name in vars) {
          var variable = vars[name];
          var result = variable[0];
          var unit = variable[1] || '';
          var value = typeof result === 'function' ? result(props) : result;
          warnIfInvalid(value, options.name);
          style["--".concat(name)] = "".concat(value).concat(unit);
        }

        filteredProps.style = Object.assign(style, filteredProps.style);
      }

      if (tag.__linaria && tag !== component) {
        // If the underlying tag is a styled component, forward the `as` prop
        // Otherwise the styles from the underlying component will be ignored
        filteredProps.as = component;
        return /*#__PURE__*/React.createElement(tag, filteredProps);
      }

      return /*#__PURE__*/React.createElement(component, filteredProps);
    };

    var Result = React.forwardRef ? /*#__PURE__*/React.forwardRef(render) : // React.forwardRef won't available on older React versions and in Preact
    // Fallback to a innerRef prop in that case
    function (props) {
      var rest = restOp(props, ['innerRef']);
      return render(rest, props.innerRef);
    };
    Result.displayName = options.name; // These properties will be read by the babel plugin for interpolation

    Result.__linaria = {
      className: options.class,
      extends: tag
    };
    return Result;
  };
}

export default process.env.NODE_ENV !== 'production' ? new Proxy(styled, {
  get: function get(o, prop) {
    return o(prop);
  }
}) : styled; //# sourceMappingURL=styled.js.map